import { createContext, Dispatch, SetStateAction, useState } from 'react';
import {
  DEFAULT_TIME_WHEEL_PICKER_VALUE,
  TIME_WHEEL_PICKER_DEFAULTS,
  TimeWheelPickerSize,
  TimeWheelPickerValue,
  TimeWheelPickerVariant
} from 'constants/time-wheel-picker';
import { getTimeWheelPickerInitialValue } from 'utils/time-wheel-picker.util';
import WheelPicker from './WheelPicker';

interface TimeWheelPickerProps {
  /**
   * Read once on mount to seed the picker. To reset from the parent, remount this component
   * (e.g. change `key`) - subsequent prop updates are ignored.
   */
  initialValue?: string;
  onChange: (arg: string) => void;
  wrapperClassname?: string;
  size?: TimeWheelPickerSize;
  variant?: TimeWheelPickerVariant;
  isLoading?: boolean;
}

export const TimeWheelPickerContext = createContext<{
  time: TimeWheelPickerValue;
  setTime?: Dispatch<SetStateAction<TimeWheelPickerValue>>;
  variant?: TimeWheelPickerVariant;
}>({ time: DEFAULT_TIME_WHEEL_PICKER_VALUE });

const TimeWheelPicker = ({
  initialValue,
  onChange,
  size = TIME_WHEEL_PICKER_DEFAULTS.SIZE,
  variant = TIME_WHEEL_PICKER_DEFAULTS.VARIANT,
  isLoading = false
}: TimeWheelPickerProps) => {
  const [time, setTime] = useState<TimeWheelPickerValue>(() =>
    getTimeWheelPickerInitialValue(initialValue)
  );

  return (
    <TimeWheelPickerContext.Provider value={{ time, setTime, variant }}>
      <WheelPicker
        size={size}
        variant={variant}
        onChange={onChange}
        isLoading={isLoading}
      />
    </TimeWheelPickerContext.Provider>
  );
};

export default TimeWheelPicker;
